import { config } from '@iheartjane/config';
import { clsx } from 'clsx/lite';
import { StreamChat } from 'stream-chat';
import {
  Avatar,
  Channel,
  Chat,
  MessageInput,
  MessageList,
  Thread,
  Window,
} from 'stream-chat-react';

import { useConversationContext } from './conversationProvider';
import { CustomMessage } from './customMessage';
import { CustomMessageStatus } from './customMessageStatus';

import styles from './conversation.module.css';

export const Conversation = () => {
  const chatClient = StreamChat.getInstance(config.streamChatApiToken);
  const { channel, store } = useConversationContext();
  return (
    <Chat client={chatClient}>
      <div className={styles['chat']}>
        <Channel
          channel={channel}
          Message={CustomMessage}
          MessageStatus={CustomMessageStatus}
        >
          <Window>
            <header
              className={clsx('str-chat__channel-header', styles['header'])}
            >
              <Avatar image={store.photo} name={store.name} />
              <p className="str-chat__channel-header-title">{store.name}</p>
            </header>
            <MessageList
              messageActions={
                [
                  // Hide the UI that enables shoppers' message actions -
                  // no edit, delete, quote, react, flag or pin.
                ]
              }
            />
            <MessageInput />
          </Window>
          <Thread />
        </Channel>
      </div>
    </Chat>
  );
};
